import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import BadgeIsValid from '~/components/BadgeIsValid'
import Panel from '~/components/Panel'
import { isPublisher } from '~/helpers'
import { LinkInsertionOrder } from '~/modules/retailMedia/components/LinkInsertionOrder'

import { useCampaignForm } from '../../hooks/useCampaignForm'

export const LinkInsertionOrderBlock = () => {
  const { t } = useTranslation()
  const {
    rmid,
    linkedInsertionOrder,
    setLinkedInsertionOrder,
    linkedInsertionOrderError,
    setLinkedInsertionOrderError
  } = useCampaignForm()

  const handleChange = useCallback(
    (insertionOrder: InsertionOrder | null) => {
      setLinkedInsertionOrder(insertionOrder)

      if (!insertionOrder) {
        setLinkedInsertionOrderError(null)
        return
      }

      if (!insertionOrder.checking_account_id) {
        setLinkedInsertionOrderError(
          t('rm:campaign.insertionOrder.missingCheckingAccount')
        )
        return
      }

      setLinkedInsertionOrderError(null)
    },
    [setLinkedInsertionOrder, setLinkedInsertionOrderError, t]
  )

  const description = linkedInsertionOrder?.name
    ? linkedInsertionOrder.name
    : t('rm:campaign.insertionOrder.block.description')

  const isFundingReady = Boolean(linkedInsertionOrder?.checking_account_id)

  return (
    <div data-testid="link-insertion-order-block">
      <Panel
        title={t('rm:campaign.insertionOrder.block.title')}
        description={description}
        isCollapsible
        initialCollapsibleState={!linkedInsertionOrder}
        iconLeft={<BadgeIsValid isValid={isFundingReady} />}
      >
        <LinkInsertionOrder
          value={linkedInsertionOrder}
          onChange={handleChange}
          advertiserId={isPublisher() ? rmid : undefined}
          required
          error={linkedInsertionOrderError || undefined}
        />
      </Panel>
    </div>
  )
}
